module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("To Catch a Thief")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("CHAPTER TWO")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("N"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("ELL SHIVERED IN THE")])])])]), _vm._v(" biting wind, painfully aware that every second they were losing light.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("So far she had managed to guide five of the teens down, turning them over to the Scottish SAR people at the waist of the mountain. The sixth one was clipped in and ready to escort down.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But conditions were getting risky. In a few minutes all light would be gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She rechecked all the carabiners and anchors, then gave a reassuring smile to the gangly boy who was watching her in abject adoration. “You’ll be fine, Jess. Just keep breathing and count your steps the way I told you. Stay cool and stay focused. I’ll be on the rope right in front of you, so don’t crowd me. Can you do all that?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I—yes.” He tried to hide his fear. “Let’s go.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell touched his face and held his gaze with the force of her own. “You’re going to survive this, Jess. The others are down and you’re next. Just do what I told you and you’ll be fine.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You—you’re amazing.” The boy gripped the safety line with both hands, but his gaze was locked on Nell. “I thought we were all dead, but you walked out of the rain like some kind of angel.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m glad I was around to help.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What about Amanda? Is she going to make it through this?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was a nice kid, Nell thought. They all were. None of them were going to die, she vowed. Not while she had hands to knot a rope and lungs to breathe in icy air.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She checked that all the carabiner gates were fully closed and secure, then gave the boy a jaunty smile. “Now get yourself down to the inn and warm up. They’ll have a fire and dry clothes ready. Drinks tonight in the pub are on me. Cokes, of course.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He smiled crookedly. “I’ll be waiting. You couldn’t keep me away.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell looked down into the swirling blanket of clouds and gave two short bursts on her whistle. Seconds later she heard the faint answering notes from the SAR people waiting at the end of the safety line, followed by the answering whistle from her climbing partner lower down the slope.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Then a gust of wind slammed over the cliff face and she forgot everything but keeping her footing as darkness closed in around them.")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("W"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("HAT THE HELL")])])])])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("was taking her so long?")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dakota stood at the top of the safety line and checked the luminous dial of his watch. Nell had been gone almost twenty minutes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He fought an urge to follow the line in search of her, but he needed to go back to keep an eye on Amanda, who had roused once, asked for water, then slipped back into unconsciousness, struggling for breath.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Asthma and possible internal bleeding, with hypothermia a distinct risk. In addition, the British tour leader had nausea, sweating and crushing chest pains that radiated down his left arm, clear indicators of a heart attack. Dakota had given him a small aspirin to chew, followed by sublingual nitro, but the man didn’t look good.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He couldn’t afford to lose Nell in the storm, the SEAL thought grimly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He stared down at the safety line, thinking about the night two weeks before when a Renaissance masterpiece worth thirty million dollars had disappeared from a locked vault….")])]), _c('p', {
    staticClass: "chapterDateline1"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Washington, D.C.")])])])]), _c('p', {
    staticClass: "chapterDateline"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("South Conservation Workroom of the National Gallery")])])])]), _c('p', {
    staticClass: "chapterDateline2"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Two weeks earlier")])])])]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("HE SECURITY LIGHTS BLINKED")])]), _vm._v(",")])]), _vm._v(" a nonstop race of green against a high-tech control panel. The night guard, fresh from six years at the Metropolitan Museum in New York, reached for his log sheet to verify a completed security cycle.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Even then his eyes didn’t leave the sleek security panel, where half a dozen cameras picked up deserted hallways and an empty loading dock. Two floors above, Rogers walked the offices, checking every door. At the end of the hall he used his passkey to call the elevator, then continued on his rounds.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The night was quiet and uneventful. Even the streets were calm, with no sirens for several hours. But the museum was on special security measures due to a new piece of art entered for appraisal. Only five people on the staff knew that the work was judged to be from the hand of Leonardo da Vinci, a Renaissance masterpiece that would command millions when it eventually went up for auction.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The air-conditioning clicked. The head guard, Everett Jonell, checked the control panel. Lights flickered briefly. The locked room with the new da Vinci blurred to gray.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Everett’s hand went to the alarm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Then the power came back on, with the hum of the HVAC restored. The row of monitors showed empty corridors. The door to the vault in south storeroom #3-A was locked as before.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Everett Jonell relaxed, leaning back in his chair. He felt sweat bead his forehead and shook his head. He’d be relieved when the art in storeroom #3-A was on its way and things settled back to normal. Until then, people would be edgy, under orders to report anything that seemed unusual.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("On the black-and-white monitor, Jonell watched Rogers cross the big atrium and move toward the new sculpture wing. There was something off about the man. Two nights earlier Jonell had stopped at a small jazz club for a drink after work and he’d noticed Rogers getting out of a parked car across the street. The sleek black Mercedes M-Class sedan had seemed way above Rogers’s pay grade, so Jonell had made a point of checking out the driver and noting the license plate.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d been surprised to see one of the senior curators emerge, a slender workaholic from Harvard who never went anywhere without her cell phone headset in place. There were no explicit rules forbidding social contact between security and academic staff, but you didn’t see it happen just the same. Different worlds, different goals, Jonell thought. But the way the curator had plastered herself all over Rogers as they’d kissed long and intimately in the shadows across the street had Jonell scratching his head.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maybe you never knew what made people tick. After twelve years in the Marines he’d seen a lot of things and figured he was a good judge of people. Rogers seemed like an okay guy, but it wasn’t up to Jonell to judge.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d report what he’d seen to the head of museum personnel, just in case. Until the da Vinci in storeroom #3-A left the premises safely, they would all be under extra scrutiny and Jonell wasn’t risking his job and a nice pension for anything. Not with a new grandbaby on the way and three more years until Medicare kicked in.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He frowned into the security monitor as he saw Rogers reach into his pocket and pull out a cell phone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What was the man doing? He knew that personal cell phone use was forbidden during work hours for security. Now Jonell would have to write the man up, which involved reports in triplicate and copies to both union representatives.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Blast the man. Didn’t he know that the video cameras would pick him up?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The monitors flickered again and the HVAC clicked off. Lightning crackled high overhead, the sound muffled by the museum’s thick walls.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jonell sat forward as all the monitors went dark. Cursing, he lunged for the security phone, but the line was dead. He grabbed the battery-powered walkie-talkie to put in a radio alert to the general switchboard, standard procedure, even though a backup generator would kick in any second.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The movement came from his left and he dropped the walkie talkie as a leather strap locked him to the chair, his hands caught behind his back. He struggled against cool fingers that gripped his neck.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, you can’t—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The needle prick came quickly, burning against the inside of his nose, which made no sense at all. The room blurred and he tried to speak as he heard the sound of the security panel door being unlocked. Someone was removing the surveillance board timer, he realized. Blurring fingers ejected the surveillance disk.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It had all been planned to the second, Jonell thought dimly. Planned by someone on the inside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Was it Rogers? Another one of the new guards they had hired in the past month?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He moaned, caught by crushing pain at his chest. As his body went slack, Everett Jonell realized that he’d never see the new grandbaby or his wife or his proud daughter again. The sorrow was the last thing he felt.")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("IX MINUTES")])])])])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v(", fifteen seconds to go.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The figure at the security command post inserted a new time stamp digitally at the security panel, typing in a string of computer code. Then he pocketed the old surveillance disk and inserted a new one, already formatted and complete with museum images calibrated to the current time stamp. Nothing had been left to chance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nudging his boss’s lifeless body onto the floor, the figure finished his disk exchange and then checked the black-and-white images that appeared on the row of monitors.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("All good to go.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He opened his cell phone, dialed a number and hung up after one ring.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Though the far monitor showed no activity, he knew that someone was carefully easing open the door of storeroom #3-A at that very moment.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He closed his eyes, savoring his memory of the exquisite chalk sketch of the most famous woman on the planet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Thanks to his discreet program override, the monitor display would loop back with preset images and movements timed to coincide with normal museum patterns. After the thorough infrared assessments that had just been completed, no new tests on the art were scheduled for thirty-six hours. Only at that point would the theft be discovered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("By then, da Vinci’s preparatory ink and chalk study for the Mona Lisa would be safely locked in a vault, ready for covert transport out of the U.S.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He checked his watch.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Three minutes, twenty-two seconds to go. Calmly he lifted Jonell’s fallen walkie-talkie and studied its face. Everything appeared to be in working order, he was happy to see.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His cell phone buzzed quietly, one burst and then no more.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("All clear.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Target acquired and clues in place. Ready to exit the building")])]), _vm._v(". Everything was moving nicely ahead of schedule.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He thought briefly about the funds that would be wired to four of his offshore accounts by this time tomorrow. Maybe he’d buy that island in the Seychelles after all. It was remote enough and there was a fresh water source as well as a sizable bungalow with upgraded docks.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He shoved away the thought. There was still risky work to be done. In two minutes he would phone in an emergency call notifying the switchboard of Everett Jonell’s collapse, sounding suitably shocked and upset. Once his regular shift was complete, he would drive to the short-term apartment that he leased in northern Maryland under one of his many other names. Once there he would collect the carefully wrapped piece of art. After the transfer was done, he would follow his normal schedule with no deviation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d even attend Everett Jonell’s funeral and offer deep and sincere condolences to his wife.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d stay in place after the theft was discovered, monitoring progress on the investigation inside the museum. In six months he would resign quietly, pleading health problems, and then vanish.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He glanced at his watch.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Showtime")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He took a deep breath, schooling his features to a frown. When he triggered the walkie-talkie alert, the alarm in his voice was deeply convincing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Command post one. Guard down. I repeat—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("guard down!")])]), _vm._v(" Backup needed immediately.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was kneeling over Jonell’s lifeless body, looking pale and agitated, when the first security patrol car screamed up the museum’s back service drive.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8eecaf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tocatchathief_ch02.vue
// module id = 84
// module chunks = 0